export const ABSENCE_REASONS = [
  'GUARD_REST',
  'RTT',
  'CP',
  'TRAINING',
  'CONGRESS',
  'SICKNESS',
  'ECHANGE_DE_JOUR',
  'OTHER',
];

export const PRESENCE_REASONS = ['BLOC', 'GUARD', 'CONSULTATION', 'VACATION'];
